/* eslint-disable react/no-array-index-key */
"use client";

import cleanStack from "clean-stack";
import Link from "next/link";
import { Fragment, useEffect } from "react";
import { toast } from "sonner";

import { buttonVariants } from "~/components/button";
import { Button } from "~/components/button.client";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardIndicator, CardTitle } from "~/components/card";
import DashboardLoading from "./loading";

function reducePnpmPaths(stack?: string) {
	if (!stack) return "";

	let oldStack;
	let newStack = stack;
	const pnpmRegex = /node_modules\/\.pnpm\/[^/]+\/node_modules\//g;

	do {
		oldStack = newStack;
		newStack = newStack.replace(pnpmRegex, "node_modules/");
	} while (oldStack !== newStack);

	return newStack;
}

type PageError = { digest?: string, _componentStack: string } & Error

export function pageErrorToast(error: PageError) {
	const component = error._componentStack.split("\n").filter(Boolean)[0];

    toast.error("Something went wrong", {
			id: error.digest ? `error-${error.digest}` : undefined,
			description: component,
			duration: Infinity,
      // action: {
      //   label: "Try again",
      //   onClick: () => location.reload()
      // }
    })
}
export default function ErrorPage({ error }: { error:PageError} ) {
	useEffect(() => pageErrorToast(error), [error])
	return <DashboardLoading/>;


	const lines = reducePnpmPaths(error.stack).split("\n");
	const nodeModulesIndex = lines.findIndex((line) => line.includes("node_modules"));

	return (
		<div className="mx-auto flex size-full max-w-7xl items-center justify-center gap-4 p-4 pt-0 sm:gap-8">
			<Card className="w-full max-w-3xl">
				<CardHeader className="relative">
					<CardTitle>
						(´。＿。｀)
					</CardTitle>
					<CardIndicator className="absolute right-6 top-6 from-red-500 to-red-600">
						Error
						{" "}
						{error.digest}
					</CardIndicator>
				</CardHeader>
				<CardContent>
					<CardDescription className="overflow-auto whitespace-pre font-mono">
						<span className="font-bold text-accent-foreground">{error.message}</span>
						<br />
						<br />
						{lines.slice(0, nodeModulesIndex).map((line, index) => {
							const [method, pathname] = line.split("@");

							return (
								<span key={index}>
									<span className="text-accent-foreground">{method}</span>
									{" "}
									<span className="text-muted-foreground">{pathname}</span>
									<br />
								</span>
							);
						})}
						{nodeModulesIndex !== -1 && (
							<>
								<details className="mt-2">
									<summary className="mb-2 text-accent-foreground">Show more</summary>
									{lines.slice(nodeModulesIndex).map((line, index) => {
										const [method, pathname] = line.split("@");

										return (
											<Fragment key={index}>
												<span className="text-accent-foreground">{method}</span>
												{" "}
												<span className="whitespace-pre text-muted-foreground">{pathname}</span>
												<br />
											</Fragment>
										);
									})}
								</details>
							</>
						)}
					</CardDescription>
				</CardContent>
				<CardFooter>
					<Button
						variant="outline"
						onClick={() => window.location.reload()}
					>
						Try again
					</Button>
					<Link
						className={buttonVariants({ variant: "link" })}
						href="https://adli.ly/discord"
					>
						Support
					</Link>
				</CardFooter>
			</Card>
		</div>
	);
}
